import { hasAnyConditions } from '../../components/SprintDetail/shared/ConditionsDropdown/utils/conditionHelpers';

function onlyDependsOn(taskId) {
  return {
    version: 2,
    blocks: [{
      conditions: [{ taskId, branch: null }],
      innerOperator: 'AND',
      outerOperator: null,
    }],
  };
}

/** Attach a new campaign card the same way (+) attaches a mission. */
export function connectCampaignCard(tasks, newTask, connect) {
  if (!connect?.sourceTaskId) return { tasks, task: newTask };
  const source = tasks.find((task) => task.id === connect.sourceTaskId);
  if (!source) return { tasks, task: newTask };

  if (connect.mode === 'before') {
    const task = {
      ...newTask,
      dependsOn: hasAnyConditions(source.unlockConditions) ? [] : [...(source.dependsOn || [])],
      ...(hasAnyConditions(source.unlockConditions) ? { unlockConditions: source.unlockConditions } : {}),
    };
    const nextTasks = tasks.map((item) => {
      if (item.id !== source.id) return item;
      return {
        ...item,
        dependsOn: [newTask.id],
        ...(hasAnyConditions(item.unlockConditions) ? { unlockConditions: onlyDependsOn(newTask.id) } : {}),
      };
    });
    return { tasks: nextTasks, task };
  }

  return {
    tasks,
    task: {
      ...newTask,
      dependsOn: connect.branch
        ? [{ taskId: connect.sourceTaskId, branch: connect.branch }]
        : [connect.sourceTaskId],
    },
  };
}
